/**
 * App version and lazy changelog loader.
 *
 * The CHANGELOG array (~90KB) is split into changelog.ts and loaded
 * lazily so it does NOT land in the main JS bundle.
 */

export const APP_VERSION = 'v1.6';
export const BUILD_TIMESTAMP = new Date().toUTCString();

export interface ChangelogEntry {
  version: string;
  date: string;
  title: string;
  changes: {
    type: 'added' | 'changed' | 'fixed' | 'security' | 'removed';
    description: string;
  }[];
}

/**
 * Lazy-loads the full changelog.
 * Call this only when the user opens the changelog dialog to avoid
 * including 90KB of static data in the initial JS bundle.
 */
export const loadChangelog = (): Promise<ChangelogEntry[]> =>
  import('./changelog').then((m) => m.CHANGELOG);
